import { useTranslation } from 'react-i18next'

import { ProfileCreatedWidget } from '../../../Widget'
import { QA_NAME_VIEWING_PROFILE_WIDGET_CREATED } from '../RentalPortalViewingProfile.constants'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'
import { toViewingProfileManagerValue } from '../RentalPortalViewingProfile.utils'

function RentalPortalViewingProfileWidgetCreated() {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  return (
    <ProfileCreatedWidget
      contentProps={{
        createdAt: viewingData?.created,
        createdBy: toViewingProfileManagerValue(viewingData),
      }}
      isSkeleton={!isInitiated || !viewingData}
      title={t('Widget.CreatedTitleKey')}
      widgetProps={{ qaName: QA_NAME_VIEWING_PROFILE_WIDGET_CREATED }}
    />
  )
}

export default RentalPortalViewingProfileWidgetCreated
